export default __webpack_public_path__ + "fd2b1c1daa2c49a3a165b3a8fd1d372b.svg";